export function validateEmail(email: string): boolean {
  const trimmed = email.trim();

  // Allow any email with +<number> before @gmail.com for testing (ignore case)
  const plusTestMatch = trimmed.match(/^([\w-.]+)\+(\d+)@gmail\.com$/i);
  if (plusTestMatch) {
    return true;
  }

  // RFC 5322 Official Standard regex (simple version)
  return /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/.test(trimmed);
}
